import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';

const UserStatus = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    signOut(auth);
    navigate('/');
  };

  if (!user) return null; 

  return (
    <div style={styles.container}>
      <User size={14} color="#00FF00" />
      <span style={styles.email}>{user.email}</span>
      <button onClick={handleLogout} style={styles.logoutBtn}>LOGOUT</button>
    </div>
  );
};

const styles = {
  container: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    background: 'rgba(0,0,0,0.8)',
    padding: '8px 15px',
    borderRadius: '30px',
    border: '1px solid #333',
    backdropFilter: 'blur(5px)'
  },
  email: {
    color: '#00FF00', // <--- NEON GREEN SETTING
    fontSize: '0.8rem',
    fontFamily: 'Courier New',
    fontWeight: 'bold',
    letterSpacing: '1px'
  },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid #D4AF37',
    color: '#D4AF37',
    fontSize: '0.65rem',
    padding: '4px 8px',
    cursor: 'pointer',
    fontFamily: 'Orbitron',
    borderRadius: '4px',
    marginLeft: '10px'
  }
};

export default UserStatus;
